var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checked)?_c('span',[_vm._v("已核算")]):_c('span',{class:_vm.data.status === 'add' ? 'red' : ''},[_vm._v(_vm._s(_vm.type[_vm.data.status]))])])}
var staticRenderFns = []

export { render, staticRenderFns }